<template>
  <div v-if="isEdit" class="row mt-2">
    <div class="col-md-6">
      <div class="input-group">
        <span class="input-group-text">Target Weight (lbs)</span>
        <input
          type="Number"
          aria-label="weight"
          class="form-control custom-target-input"
          v-model="weight"
          step="any"
          min="0"
          @keyup="showSave = true"
          @change="showSave = true"
        />
        <span class="input-group-text">Target Bodyfat (%)</span>
        <input
          type="Number"
          aria-label="weight"
          class="form-control custom-target-input"
          v-model="fat"
          step="any"
          min="0"
          @keyup="showSave = true"
          @change="showSave = true"
        />
      </div>
      <div class="col-md-6"></div>
    </div>
    <div class="col-md-4">
      <button v-show="showSave" class="btn btn-danger btn-sm" @click="save">
        Save
      </button>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-8">
      <div class="row mb-2">
        <div class="col-md-4"></div>
        <div class="col-md-4 custom-header">Body Weight</div>
        <div class="col-md-4 custom-header">Body Fat</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-4">First:</div>
        <div class="col-md-4">{{ weightFirst }}</div>
        <div class="col-md-4">{{ fatFirst }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-4">{{ latestTitle }}</div>
        <div class="col-md-4">{{ weightLatest }}</div>
        <div class="col-md-4">{{ fatLatest }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-4">{{ targetTitle }}</div>
        <div class="col-md-4">{{ weightTarget }}</div>
        <div class="col-md-4">{{ fatTarget }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12 custom-header">{{ lastSetTitle }}</div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="row mb-2">
        <div class="col-md-12 custom-header">Progress</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6">Body Weight:</div>
        <div class="col-md-6">
          <progress-gauge :progress="weightProgress" />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6">Body Fat:</div>
        <div class="col-md-6">
          <progress-gauge :progress="fatProgress" />
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      <bodyfat-ranges :ranges="ranges" />
    </div>
    <div class="col-md-3"></div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZInput from '@/Components/ZElements/Input'
import ProgressGauge from '@/Components/UserCardio/elements/progress-gauge'
import BodyfatRanges from '@/Components/UserCardio/elements/bodyfat-ranges'
export default {
  name: 'bodycomp-measurements',
  components: {
    ZInput,
    ProgressGauge,
    BodyfatRanges,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSave: false,
      targetFat: 0,
      targetWeight: 0,
    }
  },
  mounted() {
    this.showSave = false
  },
  emits: ['saved'],
  computed: {
    ...mapGetters('bodycomposition', ['bodycomposition']),
    ...mapGetters('usercardio', ['member']),
    latestTitle() {
      return this.bodycomposition
        ? `Latest (${this.bodycomposition.measurementDate}):`
        : null
    },
    targetTitle() {
      return this.bodycomposition
        ? `Target (${this.bodycomposition.targetLastSet}):`
        : null
    },
    lastSetTitle() {
      return this.bodycomposition
        ? this.bodycomposition.targetLastSetDays
        : null
    },
    weightFirst() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.firstBodyWeight).toFixed(1)} lbs`
        : null
    },
    weightLatest() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.bodyWeight).toFixed(1)} lbs`
        : null
    },
    weightTarget() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.targetBodyWeight).toFixed(1)} lbs`
        : null
    },
    fatFirst() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.firstBodyFat).toFixed(1)}%`
        : null
    },
    fatLatest() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.bodyFat).toFixed(1)}%`
        : null
    },
    fatTarget() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.targetBodyFat).toFixed(1)}%`
        : null
    },
    weightProgress() {
      return this.bodycomposition ? this.bodycomposition.weightProgress : null
    },
    fatProgress() {
      return this.bodycomposition ? this.bodycomposition.fatProgress : null
    },
    ranges() {
      return this.bodycomposition ? this.bodycomposition.bodyfatnorms : null
    },
    weight: {
      get() {
        let _data = 0
        if (this.bodycomposition) {
          _data = this.bodycomposition.targetBodyWeight
          this.targetWeight = this.bodycomposition.targetBodyWeight
        }
        return _data
      },
      set(value) {
        this.targetWeight = value
      },
    },
    fat: {
      get() {
        let _data = 0
        if (this.bodycomposition) {
          _data = this.bodycomposition.targetBodyFat
          this.targetFat = this.bodycomposition.targetBodyFat
        }
        return _data
      },
      set(value) {
        this.targetFat = value
      },
    },
  },
  methods: {
    ...mapActions('bodycomposition', ['saveTarget']),
    async save() {
      let data = {
        user_id: this.member ? this.member.id : null,
        currentbodyweight: this.bodycomposition
          ? this.bodycomposition.bodyWeight
          : null,
        currentbodyfat: this.bodycomposition
          ? this.bodycomposition.bodyFat
          : null,
        targetbodyweight: this.targetWeight,
        targetbodyfat: this.targetFat,
      }
      console.log('Save Targets', data)
      if (data.user_id) {
        await this.saveTarget(data)
      }
      this.showSave = false
      this.$emit('saved')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  font-weight: 600;
}
.custom-target-input {
  text-align: right;
}
</style>
